import React, { useState, useEffect } from "react";
import { 
    Card, Row, Col, Form, Button, Spinner, Alert,
    InputGroup, Table
} from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import { formatCurrency } from "../utils/formatters";

export default function ModifierCommande() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
   const [formData, setFormData] = useState({
    id_fournisseur: '',
    fournisseur_nom: '',
    date_commande: '',
    date_livraison_prevue: '',
    statut: 'brouillon',  // ← Ajoutez cette ligne
    conditions_reglement: '',
    lignes: []
});
    const [errors, setErrors] = useState({});
    const [submitError, setSubmitError] = useState('');
const [statutOptions] = useState([
    { value: 'brouillon', label: 'Brouillon', icon: 'ri-draft-line', color: 'secondary' },
    { value: 'envoyee', label: 'Envoyer au fournisseur', icon: 'ri-send-plane-line', color: 'info' },
    // { value: 'recue_partielle', label: 'Réception partielle', icon: 'ri-stack-line', color: 'warning' },
    // { value: 'recue_complete', label: 'Réception complète', icon: 'ri-check-double-line', color: 'success' },
    
    
    { value: 'annulee', label: 'Annuler', icon: 'ri-close-circle-line', color: 'danger' }
]);
    useEffect(() => {
        fetchCommande();
    }, [id]);

   const fetchCommande = async () => {
    try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(
            `https://sawd.julesferry-ga.com/api/commandes_fournisseurs.php?id=${id}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        );
        
        if (!response.ok) throw new Error("Erreur chargement");
        
        const result = await response.json();
        setFormData({
            id_fournisseur: result.data.id_fournisseur,
            fournisseur_nom: result.data.fournisseur_nom,
            date_commande: result.data.date_commande,
            date_livraison_prevue: result.data.date_livraison_prevue || '',
            statut: result.data.statut || 'brouillon',  // ← Ajoutez cette ligne
            conditions_reglement: result.data.conditions_reglement || '',
            lignes: result.data.lignes || []
        });
    } catch (err) {
        setSubmitError(err.message);
    } finally {
        setLoading(false);
    }
};

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

   const handleLigneChange = (index, field, value) => {
    const newLignes = [...formData.lignes];
    
    // Convertir en nombre selon le champ
    if (field === 'quantite_commandee') {
        newLignes[index][field] = parseInt(value) || 0;
    } else if (field === 'prix_unitaire_ht' || field === 'remise') {
        newLignes[index][field] = parseFloat(value) || 0;
    } else {
        newLignes[index][field] = value;
    }
    
    // Recalculer le montant de la ligne
    const ligne = newLignes[index];
    const quantite = parseFloat(ligne.quantite_commandee) || 0;
    const prix = parseFloat(ligne.prix_unitaire_ht) || 0;
    const remise = parseFloat(ligne.remise) || 0;
    
    ligne.montant_ligne_ht = quantite * prix * (1 - remise / 100);
    
    setFormData({ ...formData, lignes: newLignes });
};

    const handleSupprimerLigne = (index) => {
        const newLignes = formData.lignes.filter((_, i) => i !== index);
        setFormData({ ...formData, lignes: newLignes });
    };

   const calculerTotaux = () => {
    // Convertir chaque ligne en nombres
    const lignesCalculees = formData.lignes.map(ligne => ({
        ...ligne,
        quantite_commandee: parseFloat(ligne.quantite_commandee) || 0,
        prix_unitaire_ht: parseFloat(ligne.prix_unitaire_ht) || 0,
        remise: parseFloat(ligne.remise) || 0,
        tva_taux: parseFloat(ligne.tva_taux) || 18,
        css_taux: parseFloat(ligne.css_taux) || 1
    }));

    // Calculer le montant HT pour chaque ligne
    const montantHTTotal = lignesCalculees.reduce((acc, ligne) => {
        const montantLigne = ligne.quantite_commandee * ligne.prix_unitaire_ht * (1 - ligne.remise / 100);
        return acc + montantLigne;
    }, 0);

    // Calculer TVA et CSS
    const tvaTotal = lignesCalculees.reduce((acc, ligne) => {
        const montantLigne = ligne.quantite_commandee * ligne.prix_unitaire_ht * (1 - ligne.remise / 100);
        return acc + (montantLigne * ligne.tva_taux / 100);
    }, 0);

    const cssTotal = lignesCalculees.reduce((acc, ligne) => {
        const montantLigne = ligne.quantite_commandee * ligne.prix_unitaire_ht * (1 - ligne.remise / 100);
        return acc + (montantLigne * ligne.css_taux / 100);
    }, 0);

    return {
        montant_ht: montantHTTotal,
        montant_tva: tvaTotal,
        montant_css: cssTotal,
        montant_ttc: montantHTTotal + tvaTotal + cssTotal
    };
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.lignes.length === 0) {
        setErrors({ lignes: "Ajoutez au moins un produit" });
        return;
    }

    setSaving(true);
    setSubmitError('');

    try {
        const token = localStorage.getItem("token");
        const totaux = calculerTotaux();

        const response = await fetch(
            `https://sawd.julesferry-ga.com/api/commandes_fournisseurs.php?id=${id}`,
            {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...formData,
                    ...totaux,
                    // statut est maintenant inclus dans formData
                })
            }
        );

        const result = await response.json();

        if (result.success) {
            navigate('/achats/commandes');
        } else {
            setSubmitError(result.message || "Erreur lors de la modification");
        }
    } catch (err) {
        setSubmitError("Erreur de connexion au serveur");
    } finally {
        setSaving(false);
    }
};

    const totaux = calculerTotaux();

    if (loading) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <div className="d-flex justify-content-center">
                        <Spinner animation="border" variant="primary" />
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">
                    <Row className="mb-4">
                        <Col md={12}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h1 className="page-title mb-1">Modifier la commande</h1>
                                    <p className="text-muted">{formData.fournisseur_nom}</p>
                                </div>
                                <Button variant="outline-secondary" onClick={() => navigate('/achats/commandes')}>
                                    <i className="ri-arrow-left-line me-2"></i>Retour
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    {submitError && (
                        <Alert variant="danger">{submitError}</Alert>
                    )}

                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={8}>
                                <Card className="border-0 shadow-sm mb-4">
                                    <Card.Header className="bg-white">
                                        <h5 className="mb-0">Dates</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Date commande</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="date_commande"
                                                        value={formData.date_commande}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Date livraison prévue</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="date_livraison_prevue"
                                                        value={formData.date_livraison_prevue}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>


                                {/* Statut */}
<Form.Group className="mb-4">
    <Form.Label className="fw-semibold">Statut de la commande</Form.Label>
    
    <Row className="g-2">
        {statutOptions.map(option => (
            <Col lg={4} key={option.value}>
                <Button
                    variant={formData.statut === option.value ? option.color : `outline-${option.color}`}
                    className="w-100 text-start d-flex align-items-center gap-2 py-2"
                    onClick={() => setFormData({...formData, statut: option.value})}
                    style={{
                        borderRadius: '10px',
                        borderWidth: formData.statut === option.value ? '2px' : '1px',
                        whiteSpace: 'normal',
                        textAlign: 'left',
                        height: '100%',
                        transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                        if (formData.statut !== option.value) {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                        }
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                    }}
                >
                    <div className="d-flex align-items-center w-100">
                        <i className={option.icon} style={{ fontSize: '1.2rem', width: '24px' }}></i>
                        <span className="flex-grow-1 mx-1">{option.label}</span>
                        {formData.statut === option.value ? (
                            <i className="ri-checkbox-circle-fill ms-auto" style={{ fontSize: '1.2rem' }}></i>
                        ) : (
                            <span style={{ width: '20px' }}></span> /* Espace réservé pour l'alignement */
                        )}
                    </div>
                </Button>
            </Col>
        ))}
    </Row>
    
    {/* Messages contextuels - avec icônes */}
    <div className="mt-3">
        {formData.statut === 'envoyee' && (
            <Alert variant="info" className="small p-2 mb-0" style={{ borderRadius: '8px', borderLeft: '4px solid #0dcaf0' }}>
                <i className="ri-send-plane-line me-2"></i>
                La commande sera marquée comme envoyée au fournisseur.
            </Alert>
        )}
        
        {formData.statut === 'recue_partielle' && (
            <Alert variant="warning" className="small p-2 mb-0" style={{ borderRadius: '8px', borderLeft: '4px solid #ffc107' }}>
                <i className="ri-stack-line me-2"></i>
                Vous pourrez saisir les quantités reçues partiellement.
            </Alert>
        )}
        
        {formData.statut === 'recue_complete' && (
            <Alert variant="success" className="small p-2 mb-0" style={{ borderRadius: '8px', borderLeft: '4px solid #198754' }}>
                <i className="ri-check-double-line me-2"></i>
                Tous les produits seront ajoutés au stock.
            </Alert>
        )}
        
        {formData.statut === 'annulee' && (
            <Alert variant="danger" className="small p-2 mb-0" style={{ borderRadius: '8px', borderLeft: '4px solid #dc3545' }}>
                <i className="ri-close-circle-line me-2"></i>
                La commande sera annulée. Aucun mouvement de stock ne sera effectué.
            </Alert>
        )}
    </div>
</Form.Group>

                                <Card className="border-0 shadow-sm">
                                    <Card.Header className="bg-white">
                                        <h5 className="mb-0">Produits</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        {formData.lignes.length > 0 ? (
                                            <Table responsive>
                                                <thead>
                                                    <tr>
                                                        <th>Produit</th>
                                                        <th className="text-end">Qté</th>
                                                        <th className="text-end">Prix unit.</th>
                                                        <th className="text-end">Remise</th>
                                                        <th className="text-end">Total HT</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {formData.lignes.map((ligne, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {ligne.designation}
                                                                <div><small className="text-muted">{ligne.reference}</small></div>
                                                            </td>
                                                            <td className="text-end">
                                                                <Form.Control
                                                                    type="number"
                                                                    min="1"
                                                                    value={ligne.quantite_commandee}
                                                                    onChange={(e) => handleLigneChange(index, 'quantite_commandee', parseInt(e.target.value) || 1)}
                                                                    style={{ width: '80px', display: 'inline-block' }}
                                                                />
                                                            </td>
                                                            <td className="text-end">
                                                                <InputGroup size="sm">
                                                                    <Form.Control
                                                                        type="number"
                                                                        min="0"
                                                                        step="0.01"
                                                                        value={ligne.prix_unitaire_ht}
                                                                        onChange={(e) => handleLigneChange(index, 'prix_unitaire_ht', parseFloat(e.target.value) || 0)}
                                                                        style={{ width: '100px' }}
                                                                    />
                                                                    <InputGroup.Text>FCFA</InputGroup.Text>
                                                                </InputGroup>
                                                            </td>
                                                            <td className="text-end">
                                                                <Form.Control
                                                                    type="number"
                                                                    min="0"
                                                                    max="100"
                                                                    value={ligne.remise || 0}
                                                                    onChange={(e) => handleLigneChange(index, 'remise', parseFloat(e.target.value) || 0)}
                                                                    style={{ width: '60px', display: 'inline-block' }}
                                                                />%
                                                            </td>
                                                            <td className="text-end fw-bold">
                                                                {formatCurrency(ligne.montant_ligne_ht || 0)}
                                                            </td>
                                                            <td className="text-center">
                                                                <Button 
                                                                    variant="link" 
                                                                    className="text-danger p-0"
                                                                    onClick={() => handleSupprimerLigne(index)}
                                                                >
                                                                    <i className="ri-delete-bin-line"></i>
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        ) : (
                                            <p className="text-muted text-center py-3">Aucun produit</p>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>

                         <Col md={4}>
    <Card className="border-0 shadow-sm sticky-top" style={{ top: '20px' }}>
        <Card.Header className="bg-white">
            <h5 className="mb-0">Résumé</h5>
        </Card.Header>
        <Card.Body>
            {/* Total HT */}
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <small className="text-muted">Total HT</small>
                <h4 className="mb-0 text-dark">{formatCurrency(totaux.montant_ht || 0)}</h4>
            </div>
            
            {/* TVA */}
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <small className="text-muted">TVA (18%)</small>
                <h5 className="mb-0 text-muted">{formatCurrency(totaux.montant_tva || 0)}</h5>
            </div>
            
            {/* CSS */}
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <small className="text-muted">CSS (1%)</small>
                <h5 className="mb-0 text-muted">{formatCurrency(totaux.montant_css || 0)}</h5>
            </div>
            
            <hr />
            
            {/* Total TTC */}
            <div className="mb-4 d-flex justify-content-between align-items-center">
                <span className="fw-semibold">Total TTC</span>
                <h2 className="mb-0 text-primary">{formatCurrency(totaux.montant_ttc || 0)}</h2>
            </div>

            {/* Sélecteur de statut */}
            <Form.Group className="mb-4 d-none">
                <Form.Label className="fw-semibold">Statut de la commande</Form.Label>
                <div className="d-flex flex-column gap-2">
                    {statutOptions.map(option => (
                        <Button
                            key={option.value}
                            variant={formData.statut === option.value ? option.color : `outline-${option.color}`}
                            className="w-100 text-start d-flex align-items-center gap-2 py-2"
                            onClick={() => setFormData({...formData, statut: option.value})}
                            style={{
                                borderRadius: '10px',
                                borderWidth: formData.statut === option.value ? '2px' : '1px'
                            }}
                        >
                            <i className={option.icon}></i>
                            <span>{option.label}</span>
                            {formData.statut === option.value && (
                                <i className="ri-check-line ms-auto"></i>
                            )}
                        </Button>
                    ))}
                </div>
                
                {/* Messages contextuels */}
                {formData.statut === 'envoyee' && (
                    <Alert variant="info" className="mt-3 small p-2">
                        <i className="ri-information-line me-2"></i>
                        Le statut "Envoyée" signifie que la commande a été transmise au fournisseur.
                    </Alert>
                )}
                
                {formData.statut === 'recue_complete' && (
                    <Alert variant="success" className="mt-3 small p-2">
                        <i className="ri-check-line me-2"></i>
                        Le stock sera automatiquement mis à jour.
                    </Alert>
                )}
                
                {formData.statut === 'annulee' && (
                    <Alert variant="danger" className="mt-3 small p-2">
                        <i className="ri-alert-line me-2"></i>
                        Attention : Cette action est irréversible.
                    </Alert>
                )}
            </Form.Group>

            {/* Conditions de règlement */}
            <Form.Group className="mb-3">
                <Form.Label>Conditions de règlement</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={2}
                    name="conditions_reglement"
                    value={formData.conditions_reglement || ''}
                    onChange={handleChange}
                    placeholder="Ex: Paiement sous 30 jours..."
                />
            </Form.Group>

            {/* Bouton de sauvegarde */}
            <Button 
                type="submit" 
                variant="primary" 
                className="w-100 py-3"
                disabled={saving}
                style={{
                    background: 'linear-gradient(135deg, #4361ee, #3a56d4)',
                    border: 'none',
                    borderRadius: '10px'
                }}
            >
                {saving ? (
                    <>
                        <Spinner size="sm" className="me-2" />
                        Enregistrement...
                    </>
                ) : (
                    <>
                        <i className="ri-save-line me-2"></i>
                        Enregistrer les modifications
                    </>
                )}
            </Button>
        </Card.Body>
    </Card>
</Col>
                        </Row>
                    </Form>
                </div>
                <Footer />
            </div>
        </>
    );
}